import { DeliveryCampaignProviderService } from './openapi_gen/deliveryProviderPortal/deliveryCampaignProvider';
import { DeliveryProviderService } from './openapi_gen/deliveryProviderPortal/deliveryProvider';
import { DeliveryProviderNoAuthService } from './openapi_gen/deliveryProviderPortal/deliveryProviderNoAuth';
import { DeliveryProviderPortalService } from './openapi_gen/deliveryProviderPortal/deliveryProviderPortal';
import { DeliveryProviderPortalNoAuthService } from './openapi_gen/deliveryProviderPortal/deliveryProviderPortalNoAuth';
import { LocationSuggestionsDeliveryNoAuthService } from './openapi_gen/deliveryProviderPortal/locationSuggestionsDeliveryNoAuth';
import { DeliveryProviderAuthService } from './openapi_gen/deliveryProviderPortal/deliveryProviderAuth';
import { DeliveryProviderAuthNoAuthService } from './openapi_gen/deliveryProviderPortal/deliveryProviderAuthNoAuth';

type JWTAPIClients =
  | DeliveryCampaignProviderService.ApiClient
  | DeliveryProviderService.ApiClient
  | DeliveryProviderPortalService.ApiClient;
type UnauthenticatedAPIClients =
  | DeliveryProviderNoAuthService.ApiClient
  | DeliveryProviderPortalNoAuthService.ApiClient
  | LocationSuggestionsDeliveryNoAuthService.ApiClient;

export type JWTHttpClient = JWTAPIClients['httpClient'];
export type UnauthenticatedHttpClient = UnauthenticatedAPIClients['httpClient'];

export type JWTClientConstraints =
  | DeliveryCampaignProviderService.HttpClientConstraints
  | DeliveryProviderService.HttpClientConstraints
  | DeliveryProviderPortalService.HttpClientConstraints;
export type UnauthenticatedClientConstraints =
  | DeliveryProviderNoAuthService.HttpClientConstraints
  | DeliveryProviderPortalNoAuthService.HttpClientConstraints
  | LocationSuggestionsDeliveryNoAuthService.HttpClientConstraints;

export class ApiClient {
  public readonly deliveryCampaignProvider: DeliveryCampaignProviderService.ApiClient;
  public readonly deliveryProvider: DeliveryProviderService.ApiClient;
  public readonly deliveryProviderNoAuth: DeliveryProviderNoAuthService.ApiClient;
  public readonly deliveryProviderPortal: DeliveryProviderPortalService.ApiClient;
  public readonly deliveryProviderPortalNoAuth: DeliveryProviderPortalNoAuthService.ApiClient;
  public readonly deliveryProviderAuth: DeliveryProviderAuthService.ApiClient;
  public readonly deliveryProviderAuthNoAuth: DeliveryProviderAuthNoAuthService.ApiClient;
  public readonly locationSuggestionsDeliveryNoAuth: LocationSuggestionsDeliveryNoAuthService.ApiClient;

  constructor(jwtHttpClient: JWTHttpClient, unauthenticatedHttpClient: UnauthenticatedHttpClient) {
    this.deliveryCampaignProvider = new DeliveryCampaignProviderService.ApiClient({
      httpClient: jwtHttpClient,
      apiClientOptions: { virtualPathsEnabled: true },
    });

    this.deliveryProvider = new DeliveryProviderService.ApiClient({
      httpClient: jwtHttpClient,
      apiClientOptions: { virtualPathsEnabled: true },
    });

    this.deliveryProviderNoAuth = new DeliveryProviderNoAuthService.ApiClient({
      httpClient: unauthenticatedHttpClient,
      apiClientOptions: { virtualPathsEnabled: true },
    });

    this.deliveryProviderPortal = new DeliveryProviderPortalService.ApiClient({
      httpClient: jwtHttpClient,
      apiClientOptions: { virtualPathsEnabled: true },
    });

    this.deliveryProviderPortalNoAuth = new DeliveryProviderPortalNoAuthService.ApiClient({
      httpClient: unauthenticatedHttpClient,
      apiClientOptions: { virtualPathsEnabled: true },
    });

    this.locationSuggestionsDeliveryNoAuth = new LocationSuggestionsDeliveryNoAuthService.ApiClient(
      {
        httpClient: unauthenticatedHttpClient,
        apiClientOptions: { virtualPathsEnabled: true },
      },
    );

    this.deliveryProviderAuth = new DeliveryProviderAuthService.ApiClient({
      httpClient: jwtHttpClient,
      apiClientOptions: { virtualPathsEnabled: true },
    });

    this.deliveryProviderAuthNoAuth = new DeliveryProviderAuthNoAuthService.ApiClient({
      httpClient: unauthenticatedHttpClient,
      apiClientOptions: { virtualPathsEnabled: true },
    });
  }
}
